export const iconFontAwesomeMoneyDongSign = (
	<i className="fa-solid fa-dong-sign"></i>
);
